import styles from "./Pill.module.css";

export const Pill = ({
  children,
  color,
  bg,
  border,
  size = "normal",
  className = "",
}) => {
  return (
    <span
      className={`${styles.pill} ${size === "large" ? styles.pillLarge : ""} ${className}`}
      style={{
        color,
        backgroundColor: bg,
        borderColor: border,
      }}
    >
      {children}
    </span>
  );
};
